import type { RefresherEventDetail } from '@ionic/core/components';
import {
  IonContent,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonCol,
  IonGrid,
  IonRow,
  IonCard,
  IonLabel,
  IonText,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonIcon,
  IonModal,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonLoading,
  useIonToast,
  IonSearchbar,
  IonSkeletonText,
  IonSelectOption,
  IonChip,
  IonSelect,
} from '@ionic/react';
import { MenuItem, Select } from '@material-ui/core';
import { chevronDownCircleOutline, close, closeCircle, constructOutline } from 'ionicons/icons';
import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import axios from '../../axios';
import Header from '../../components/Header';
import NoRecords from '../../components/NoRecords';
import { createAssetFields } from '../../models/createAssetFields';
import { AppContext } from '../../providers/AppContext';
import { getStatusColor, isFormDataEmpty } from '../../utils';

const AllAssets: React.FC = () => {
  const [data, setData] = useState<any>({
    dataSet: [],
    loading: false,
  });
  const [present] = useIonToast();
  const { state } = useContext(AppContext);

  const [isLoading, setIsLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(0);

  const [searchText, setSearchText] = useState('');
  const [filter] = useState<string>();
  const { t } = useTranslation();

  const [status, setStatus] = useState('');
  const [activef, setActivef] = useState({
    status: [],
  });

  const [update, setUpdate] = useState<any>({
    status: '',
    asset_state: '',
    brand: '',
    model: '',
    year: '',
    comment: '',
    // asset_component: []
  });
  // const [showModal,setShowModal] = useState(false)
  const [fabModal, setFabModal] = useState(false);
  const [loaderM, setLoaderM] = useState(false);
  const [_data] = useState<any>(createAssetFields);
  const [pname, setPname] = useState('');

  const [primaryData, setPrimaryData] = useState<any>({});

  const handleUpdateStatus = (event: any) => {
    const formentry: any = { ...update };

    if (event.target.name in formentry) {

      formentry[event.target.name] = event.target.value;
    }
    setUpdate(formentry);
  };

  // const handleMultiSelectChange = (event: string) => {
  //   const formentry: any = { ...update };
  //   // formentry['asset_component'] = event
  //   setUpdate(formentry);
  // };

  const handleChangeQuickUpdate = (event: any) => {
    const formentry: any = { ...update };
    if (event.target.id in formentry) {
      formentry[event.target.id] = event.target.value;
    }
    setUpdate(formentry);
  };

  const [disableInfiniteScroll, setDisableInfiniteScroll] = useState<boolean>(false);

  const getData = (context: any) => {
    let url = `method/preflet_asset.api.get_assets_active_tasks?limit_page_length=${state.maxLength}&limit_start=${context.isFiltered ? 0 : currentPage * 10 + 0
      }&fields=["*"]`;

    // add search data if any
    if ('search' in context || searchText) {
      setSearchText(context.search || '');
      if (context.search) url += `&search=${context.search || searchText}`;
    }

    if ('status' in context) {
      setStatus(context.status);
      url += context?.status ? `&status=${context.status}` : '';
    }
    setIsLoading(true);

    const config: any = {
      method: 'get',
      url,
      headers: {
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
    };
    axios(config)
      .then((res: any) => {
        if (res?.data?.message && res.data.message?.length > 0) {
          if (context.isFiltered) {
            const rawData = { dataSet: [], loading: false };
            rawData.dataSet = res.data.message;
            setData(rawData);
          } else {
            const rawData = { ...data };

            rawData.dataSet.push(...res.data.message);
            setData(rawData);
          }
          setDisableInfiniteScroll(res.data.message.length < state.maxLength);
        } else {

          if (context?.status) {
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            present({
              message: `${t('Assets.NoDataFoundFor')} ${context?.status}`,
              duration: 3000,
            });
            const rawData = { dataSet: [], loading: false };
            rawData.dataSet = res.data.message;
            setData(rawData);
          } else {
            const value = { ...data };
            setData(value);
          }
          setDisableInfiniteScroll(true);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
        setCurrentPage(currentPage + 1);
      });
  };

  useEffect(() => {
    getData({});
  }, []);

  function doRefresh(event: CustomEvent<RefresherEventDetail>) {
    getData({});
    setTimeout(() => {
      event.detail.complete();
    }, 2000);
  }

  async function searchNext($event: CustomEvent<void>) {
    await getData({});

    ($event.target as HTMLIonInfiniteScrollElement).complete();
  }



  const handleSearch = (value: any) => {
    getData({ search: value, isFiltered: true });
  }

  const filterFunc = async (keyname: any, value: string) => {
    const temp: any = { ...activef };
    if (keyname === 'status') {
      temp.status = [];

      temp.status.push(value);
    }
    setActivef(temp);
  };

  const clearFilter = async (keyname: any, item: any) => {
    const temp = { ...activef };
    if (keyname === 'status') {
      try {
        temp.status = temp.status.filter((e) => e !== item);
        setStatus('');
      } catch (error: any) { /*empty*/ }
    }
    setActivef(temp);
    getData({ isFiltered: true });
  };

  const SubmitStatusUpdate = async (e: any) => {
    e.preventDefault();
    const formData = new FormData();
    const temp: any = { ...update }
    for (const item in temp) {

      if (item === 'attachment' && temp['attachment']?.src) {
        try {

          const response = await fetch(temp['attachment']?.src?.toString());
          const blob = await response.blob();
          formData.append(
            'attachment',

            new File([blob], `${pname}-attachment.${temp['attachment'].format}`, {

              type: `image/${temp['attachment'].format}`,
            })
          );
        } catch (e: any) {
          console.log(e)
        }
      }
      //  else if (item === 'asset_component') {
      //   if (temp[item].length > 0) {
      //     const assComp = [] as any;
      //     for (const element in temp['asset_component']) {
      //       assComp.push({
      //         asset_component: temp['asset_component'][element]
      //       })
      //     }

      //     if (!checkIfArraysAreSame(primaryData[item], assComp))
      //       formData.append('asset_component', JSON.stringify(assComp));
      //   }
      // }
      else if (item === 'attachment' && (primaryData[item] !== temp[item].value)) {

        formData.append('attachment', temp[item].value);
      }

      else if (temp[item] !== '' && temp[item] !== null && temp[item] !== undefined && temp[item] !== 'undefined') {

        if ((primaryData[item] !== temp[item]) && item !== 'attachment')

          formData.append(item, temp[item]);
      }
    }

    const config: any = {
      method: 'put',
      url: `method/preflet_asset.api.update_asset/${pname}`,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
      data: formData,
    };
    if (!isFormDataEmpty(formData)) {
      // Update status api
      try {
        setLoaderM(true);
        await axios(config);
      } catch (error: any) {
        console.log(error);
      }

      // Update comment
      try {
        setLoaderM(true);
        const config_comment: any = {
          method: 'post',
          url: 'resource/Comment',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
          },
          data: {
            comment_type: 'Comment',
            reference_doctype: 'Asset',
            reference_name: pname,
            content: update.comment,
          },
        };

        await axios(config_comment);
      } catch (error: any) {
        console.log(error);
      } finally {
        setLoaderM(false);
        setFabModal(false);
        present({
          message: t('Assets.CreateA.assetUpdateSuccesss'),
          duration: 2000,
        });
      }
      getData({});
      setUpdate({
        status: '',
        asset_state: '',
        brand: '',
        model: '',
        year: '',
        comment: '',  // comment 
        // asset_component: [],
      });
    } else {
      setFabModal(false);
    }

  };

  const modalFunc = async (param: any) => {
    setFabModal(true);
    // const Data = [..._data];
    // /* Get Asset Component to link Asset */
    // const acname = Data.findIndex((d) => d.field === 'asset_component');
    // Data[acname].options = await getAssetComponentByLabel();
    // set_Data(Data);

    const config: any = {
      method: 'get',
      url: `resource/Asset/${param}`,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
    };
    // const assetComponent: { asset_component: any; }[] = []
    try {
      const statusData = await axios(config)
      // statusData?.data?.data?.asset_component.map((item: any) => {
      //   assetComponent.push(item?.asset_component)
      // })

      setPrimaryData(statusData?.data?.data);

      for (const x in data.dataSet) {

        if (data.dataSet[x].name === param) {
          const formentry: any = { ...update };
          formentry.status = statusData?.data?.data?.status
          formentry.asset_state = statusData?.data?.data?.asset_state
          formentry.brand = statusData?.data?.data?.brand
          formentry.model = statusData?.data?.data?.model
          formentry.year = statusData?.data?.data?.year
          formentry.comment = statusData?.data?.data?.comment
          // formentry.asset_component = assetComponent
          setUpdate(formentry);
        }
      }
    } catch (error: any) {
      console.log(error);
    }
  }



  return (
    <IonPage>
      <Header enableBackButton='/assets' title={t('Assets.Assets')} />

      <IonContent>
        <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
          <IonRefresherContent
            pullingIcon={chevronDownCircleOutline}
            pullingText={t('Utils.pullRefresh')}
            refreshingSpinner="circles"
            refreshingText={t('Utils.refreshing')}
          ></IonRefresherContent>
        </IonRefresher>

        {/* ── Hero / Search + Filter bar ── */}
        <div style={{
          background: 'linear-gradient(135deg, #1d508d 0%, #2a6db5 100%)',
          padding: '16px 14px 14px',
        }}>
          {/* Search */}
          <div style={{
            display: 'flex', alignItems: 'center', gap: '10px',
            background: 'rgba(255,255,255,0.15)',
            borderRadius: '12px',
            padding: '8px 12px',
            marginBottom: '12px',
          }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.8)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            <input
              type="text"
              value={searchText}
              onChange={(e) => handleSearch(e.target.value)}
              placeholder={t('Utils.filter') + '...'}
              style={{
                background: 'transparent', border: 'none', outline: 'none',
                color: '#fff', fontSize: '14px', flex: 1,
              }}
            />
          </div>

          {/* Filter row */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
            <select
              value={status}
              onChange={(e) => {
                const val = e.target.value;
                getData({ status: val, isFiltered: true });
                setStatus(val);
                filterFunc('status', val);
              }}
              style={{
                background: status ? '#fff' : 'rgba(255,255,255,0.18)',
                color: status ? '#1d508d' : '#fff',
                border: 'none', borderRadius: '20px',
                padding: '6px 14px', fontSize: '12px', fontWeight: 600,
                cursor: 'pointer', outline: 'none',
              }}
            >
              <option value="">{t('Utils.All')} {t('Utils.status')}</option>
              <option value="Installed">{t('Utils.Installed')}</option>
              <option value="Installed and Operational">{t('Utils.Installed and Operational')}</option>
              <option value="Operational">{t('Utils.Operational')}</option>
              <option value="Installed But Not Operational">{t('Utils.Installed But Not Operational')}</option>
              <option value="Need Repairing">{t('Utils.Need Repairing')}</option>
              <option value="In Progress">{t('Utils.In Progress')}</option>
              <option value="Need Installation">{t('Utils.Need Installation')}</option>
              <option value="Replaced">{t('Utils.Replaced')}</option>
              <option value="Need Replacement">{t('Utils.Need Replacement')}</option>
            </select>

            {/* Active filter chips */}
            {activef.status.map((item: any, idx: number) => item && (
              <div key={`chip-${idx}`} style={{
                display: 'flex', alignItems: 'center', gap: '4px',
                background: '#fff', borderRadius: '20px', padding: '4px 10px',
                fontSize: '11px', fontWeight: 700, color: '#1d508d', flexShrink: 0,
              }}>
                {item}
                <IonIcon src={closeCircle} style={{ fontSize: '14px', cursor: 'pointer', color: '#e53935' }}
                  onClick={() => clearFilter('status', item)} />
              </div>
            ))}
          </div>
        </div>

        {/* ── Skeleton ── */}
        {isLoading &&
          [1, 2, 3, 4, 5, 6].map((el) => (
            <div key={el} style={{ margin: '10px 12px', borderRadius: '14px', background: '#fff', padding: '14px 16px', boxShadow: '0 3px 14px rgba(0,0,0,0.06)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                <IonSkeletonText animated style={{ width: '55%', height: '14px', borderRadius: '8px' }} />
                <IonSkeletonText animated style={{ width: '22%', height: '14px', borderRadius: '8px' }} />
              </div>
              <IonSkeletonText animated style={{ width: '38%', height: '10px', borderRadius: '8px' }} />
            </div>
          ))}

        {/* ── Asset cards ── */}
        <div style={{ padding: '10px 12px 80px' }}>
          {data.dataSet.map((item: any, key: any) => (
            <div key={`asset-card-${key}`} style={{
              background: '#fff',
              borderRadius: '14px',
              boxShadow: '0 4px 18px rgba(0,0,0,0.07)',
              marginBottom: '10px',
              padding: '14px 16px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
            }}>
              {/* Status dot */}
              <div style={{
                width: '10px', height: '10px', borderRadius: '50%',
                background: getStatusColor(item.status), flexShrink: 0,
                boxShadow: `0 0 0 3px ${getStatusColor(item.status)}33`,
              }} />

              {/* Info */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <Link to={{ pathname: '/assetDetail', state: item.name }} style={{ textDecoration: 'none' }}>
                  <p style={{ margin: 0, fontSize: '14px', fontWeight: 700, color: '#1a2a3a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {item.name}
                  </p>
                </Link>
                <p style={{ margin: '2px 0 4px', fontSize: '11px', color: '#6b7b8f', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {t('Assets.CreateA.project')}: {item.project || '—'}
                </p>
                <span style={{
                  display: 'inline-block',
                  background: `${getStatusColor(item.status)}22`,
                  color: getStatusColor(item.status),
                  borderRadius: '20px', padding: '2px 10px',
                  fontSize: '10px', fontWeight: 700,
                }}>
                  {t(`Utils.${item.status}`) || item.status}
                </span>
              </div>

              {/* Quick-update button */}
              {!!state.permissions.assets_update && (
                <div
                  onClick={() => { setPname(item.name); modalFunc(item.name); }}
                  style={{
                    background: '#eef4fd', borderRadius: '50%',
                    width: '36px', height: '36px',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    cursor: 'pointer', flexShrink: 0,
                  }}
                >
                  <IonIcon src={constructOutline} style={{ fontSize: '18px', color: '#1d508d' }} />
                </div>
              )}
            </div>
          ))}

          {/* Empty state */}
          {!isLoading && data.dataSet.length === 0 && (
            <IonRow style={{ margin: 'auto', display: 'block' }}>
              <NoRecords width="60%" smallText={false} />
            </IonRow>
          )}
        </div>

        {/* ── Infinite scroll ── */}
        {!filter && (
          <IonInfiniteScroll onIonInfinite={(e: CustomEvent<void>) => searchNext(e)}>
            <IonInfiniteScrollContent loadingSpinner="bubbles" loadingText={t('Assets.LoadingData')} />
          </IonInfiniteScroll>
        )}

        {/* ── Quick-update modal ── */}
        <IonModal isOpen={fabModal} onDidDismiss={() => setFabModal(false)}>
          <IonHeader>
            <IonToolbar color="primary">
              <div style={{ padding: '4px 16px', fontSize: '14px', fontWeight: 700, color: '#fff' }}>{pname}</div>
              <IonButtons slot="end">
                <IonButton className="line-button" onClick={() => setFabModal(false)}>
                  <IonIcon icon={close} slot="icon-only" />
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <IonLoading isOpen={loaderM} onDidDismiss={() => setLoaderM(false)} message={t('Utils.pleasewait')} />
            <form onSubmit={(e) => SubmitStatusUpdate(e)} style={{ padding: '8px 0 20px' }}>
              {_data.map((form_field: any, index: any) => {
                if (form_field.field === 'status' || form_field.field === 'asset_state') {
                  return (
                    <div key={index} className="input-container">
                      <label className="label">{t(`Assets.CreateA.${form_field.field}`)}{form_field.required ? '*' : null}</label>
                      <Select
                        className="custom-select"
                        required={form_field.required}
                        id={`${form_field.field}_choice`}
                        name={form_field.field}
                        onChange={handleUpdateStatus}
                        value={update[form_field.field]}
                        disabled={form_field.disabled || false}
                        key={`${form_field.field}-${index}`}
                      >
                        {form_field.options?.map(function (opt: any, idx: any) {
                          return (
                            <MenuItem value={`${opt}`} key={`${form_field.field}-${idx}`}>
                              <section style={{ display: 'flex', height: '1rem' }}>
                                <p style={{ color: 'rgba(31,87,148,1)', marginLeft: '0.2rem', fontSize: '12px', marginTop: '0px' }}>
                                  {form_field.translate ? t(`Assets.CreateA.${opt}`) : opt}
                                </p>
                              </section>
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </div>
                  );
                } else if (form_field.field === 'brand' || form_field.field === 'model' || form_field.field === 'year') {
                  return (
                    <div key={index} className="input-container">
                      <label className="label">{t(`Assets.CreateA.${form_field.field}`)}{form_field.required ? '*' : null}</label>
                      <input
                        className="basic-input"
                        required={false}
                        key={`${form_field.field}-${index}`}
                        id={form_field.field}
                        placeholder={t(`Assets.CreateA.${form_field.field}`)}
                        onChange={handleChangeQuickUpdate}
                        value={update[form_field.field]}
                      />
                    </div>
                  );
                } else {
                  return '';
                }
              })}
              <div className="input-container">
                <label className="label">{t(`Utils.Comment`)}</label>
                <textarea
                  className="textarea"
                  required={false}
                  key="comment"
                  id="comment"
                  placeholder={t('Utils.Add your comment')}
                  onChange={handleChangeQuickUpdate}
                  value={update.comment}
                />
              </div>
              <button className="submit-button" type="submit">{t(`Assets.CreateA.update`)}</button>
            </form>
          </IonContent>
        </IonModal>
      </IonContent>
    </IonPage>
  );
};

export default AllAssets;
